import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Container,} from "./styled";
import React from "react";
import Header from "@dropDesk/presentation/pages/subscription/ui/select_plan/total_plan/header";
import Body from "@dropDesk/presentation/pages/subscription/ui/select_plan/total_plan/body";
import Footer from "@dropDesk/presentation/pages/subscription/ui/select_plan/total_plan/footer";
import {Brightness} from "@dropDesk/domain/entities/theme/colors.entity";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {observer} from "mobx-react";
import {
    PaymentSubscriptionSimulateEntity
} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_simulate.entity";


const TotalPlan = observer((
    {
        newSubscription,
        disabled,
        loading,
        onClickConfirmPlan,
        labelFirstPayment,
        totalFirstPayment,
        hasDowngrade,
        disabledText,
        simulate,
    }: {
        newSubscription: PaymentSubscriptionEntity
        disabled: boolean;
        loading: boolean;
        onClickConfirmPlan: () => void
        labelFirstPayment: string
        totalFirstPayment: number
        hasDowngrade: boolean
        disabledText: string;
        simulate?: PaymentSubscriptionSimulateEntity
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <Container
            background={colors.onBackground}
            isDarkTheme={colors.brightness === Brightness.dark}
            border={colors.border}
        >
            <Header simulate={simulate}/>
            <Body
                newSubscription={newSubscription}
                labelFirstPayment={labelFirstPayment}
                totalFirstPayment={totalFirstPayment}
                quantityUsersNewSubs={newSubscription.quantityOfUsers}
                simulate={simulate}
            />
            <Footer
                disabled={disabled}
                loading={loading}
                onClickConfirmPlan={onClickConfirmPlan}
                hasDowngrade={hasDowngrade}
                disabledText={disabledText}
            />
        </Container>
    );
});
export default TotalPlan;
